export default {"src":"/_next/static/image/public/images/flags/flag_231.f9a41e55a066ce61a3ec4f8c7c95112b.svg","height":16,"width":24};